import { useContext, useEffect } from 'react';
import { noContentContainerProps } from '../chat-screen.props';
import { HeaderContext } from '../../../../../../utils/context';
import { HelloText, HowCanIHelpYouTodayText } from '../../data/constants';
import ChatThreadLayout from '../../../components/chat-ui/chat-thread-layout';

export function NoContentContainer({ chatScreenRef }: noContentContainerProps) {
  const { userName, setUserName } = useContext(HeaderContext);

  const name = localStorage.getItem('user_details');
  useEffect(() => {
    if (name) {
      const parsedDetails = JSON.parse(name);
      setUserName(parsedDetails?.name);
    }
  }, [name]);

  return (
    <div className="flex w-full flex-col justify-center" ref={chatScreenRef}>
      <ChatThreadLayout className="py-0">
        <div className="pl-[52px] pr-3 text-left w-full">
          <h2
            className="text-[48px] font-extrabold leading-[1.1] tracking-wide"
            style={{ color: '#F48B00' }}
          >
            {HelloText} {userName},
          </h2>
          <h2
            className="text-[48px] font-light leading-[1.1] tracking-wide"
            style={{ color: '#C4C4C4' }}
          >
            {HowCanIHelpYouTodayText}
          </h2>
        </div>
      </ChatThreadLayout>
    </div>
  );
}

export default NoContentContainer;
